import React from 'react';
import Link from 'next/link';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

const BreadCrumb: React.FC<{ list: { title: string; href: string }[] }> = ({
  list,
}) => {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {list.map(({ title, href }, index) => (
          <React.Fragment key={index}>
            <BreadcrumbItem>
              {index === list.length - 1 ? (
                <BreadcrumbPage>{title}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild href={href}>
                  <Link href={href}>{title}</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
            {index !== list.length - 1 && (
              <BreadcrumbSeparator className="rotate-180" />
            )}
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
export default BreadCrumb;
